import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  sections: Object[] = [
    { label: "overview", link: "overview" },
    { label: "library access", link: "access" },
    { label: "chemical diversity comparison", link: "diversity" },
  ];

  constructor() { }

  ngOnInit() {
  }

}
